import React, { ErrorInfo } from "react";
import { withTranslation } from "react-i18next";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import Box from "@amzn/awsui-components-react/polaris/box";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import { IErrorProps, IErrorState } from "./definitions";
import { LOG } from "utils";
import { Button } from "@amzn/awsui-components-react";
import { t } from "i18next";

const headerText = t("components.error_boundary.errorInfo");
const header = t("components.error_boundary.header");
const action = t("components.error_boundary.buttonText");
const productionMessage = t("components.error_boundary.productionMessage");

class ErrorBoundary extends React.Component<IErrorProps, IErrorState> {
  readonly exposeError: boolean = process.env.NODE_ENV === "development";
  public state: IErrorState = {
    error: undefined,
    errorInfo: undefined,
  };

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    });

    LOG.error(error, errorInfo.componentStack);
  }

  public render() {
    const { t } = this.props;

    if (this.state.error) {
      return (
        <Alert
          type="error"
          header={header}
          action={<Button>{action}</Button>}
          onButtonClick={() => {
            window.location.reload();
          }}
        >
          <Box variant="p">{productionMessage}</Box>
          {this.exposeError && (
            <Box>
              {this.state.error && (
                <Box variant="p">{this.state.error.toString()}</Box>
              )}

              {this.state.errorInfo && (
                <ExpandableSection
                  defaultExpanded
                  headerText={headerText}
                  variant="footer"
                >
                  <Box variant="code">
                    {this.state.errorInfo.componentStack}
                  </Box>
                </ExpandableSection>
              )}
            </Box>
          )}
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
